// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._295NO{text-align:center;padding:15px 0;margin-bottom:20px}._273Oz{position:absolute;right:30px;margin-top:1.5em;z-index:100}", ""]);
// Exports
exports.locals = {
	"panel": "_295NO",
	"addButton": "_273Oz"
};
module.exports = exports;
